import { render, staticRenderFns } from "./RegisterCardCNPForm.vue?vue&type=template&id=65ae0884&"
import script from "./RegisterCardCNPForm.vue?vue&type=script&lang=js&"
export * from "./RegisterCardCNPForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports